import React, { useEffect, useReducer } from "react";
import { useDispatch } from "react-redux";
import UserProvider from "../../components/common/UserProvider";
import { tabSetUserByIndex } from "../../redux/actions/tabActions";
import { userReducer } from "../../store/userReducer";
import { PrincipalDetail } from "../../views/PrincipalDetail/PrincipalDetail";
import {UserState} from "../../passapp-sdk/types/userTypes";

type PrincipalManagerProps = {
  userInitialState: UserState;
  stateTunnel?: (user: UserState) => void;
};

//Se encarga de proveer todos los datos recolectados en un solo contexto para todos los componentes
export const PrincipalManager = ({
  userInitialState,
  stateTunnel,
}: PrincipalManagerProps) => {
  const [state, dispatch] = useReducer(userReducer, userInitialState);
  const globalDispatch = useDispatch();

  useEffect(() => {
    globalDispatch(tabSetUserByIndex(state.indexTab, state));
  }, [state]);
  return (
    <UserProvider state={state} dispatch={dispatch}>
      <PrincipalDetail stateTunnel={stateTunnel} />
    </UserProvider>
  );
};
